module.exports = __webpack_public_path__ + "img/grupa_azoty.bc88219c.png";